export const fibreCopperConsolidationField = [
  {
    name: 'province',
    label: 'Service Address Province',
    type: 'multiSelect',
    isVisible: true,
    isRequired: true,
    options: [
      { label: 'Alberta', value: 'Alberta' },
      { label: 'British Columbia', value: 'British Columbia' },
      { label: 'Ontario (NON-ILEC)', value: 'Ontario (NON-ILEC)' },
      { label: 'Quebec (NON-ILEC)', value: 'Quebec (NON-ILEC)' },
      { label: 'Ontario (ILEC)', value: 'Ontario (ILEC)' },
      { label: 'Quebec (ILEC)', value: 'Quebec (ILEC)' },
      { label: 'Manitoba', value: 'Manitoba' },
      { label: 'New Brunswick', value: 'New Brunswick' },
      { label: 'Nova Scotia', value: 'Nova Scotia' },
      {
        label: 'Newfoundland and Labrador',
        value: 'Newfoundland and Labrador'
      },
      { label: 'Prince Edward Island', value: 'Prince Edward Island' },
      { label: 'Saskatchewan', value: 'Saskatchewan' }
    ]
  },
  {
    name: 'channels',
    label: 'Channel',
    type: 'multiSelect',
    isVisible: true,
    isRequired: true,
    optionsKey: 'channels',
    options: []
  },
  {
    name: 'dealerships',
    label: 'Dealership',
    type: 'multiSelect',
    isVisible: true,
    isRequired: true,
    optionsKey: 'dealers',
    options: []
  },
  {
    name: 'product',
    label: 'Product',
    type: 'multiSelect',
    isVisible: true,
    isRequired: true,
    options: [
      { label: 'Fibre Internet', value: 'Fibre Internet' },
      { label: 'Copper Internet', value: 'Copper Internet' },
      { label: 'TSB', value: 'TSB' }
    ]
  },
  // T019 [US4]: TSB Plan — mandatory multi-select; only visible when Product includes 'TSB'.
  // Positioned immediately after the Product field per FR-011 (clarified 2026-07-13).
  {
    name: 'tsbPlan',
    label: 'TSB Plan',
    type: 'multiSelect',
    isRequired: true,
    isVisible: true,
    options: [
      { label: 'Monitor', value: 'Monitor' },
      { label: 'Protect', value: 'Protect' },
      { label: 'Smart Camera', value: 'Smart Camera' }
    ]
  },
  {
    name: 'term',
    label: 'Term',
    type: 'multiSelect',
    isVisible: true,
    isRequired: true,
    options: [
      { label: 'Month to Month', value: 'Month to Month' },
      { label: '36 Months', value: '36 Months' },
      { label: '60 Months', value: '60 Months' }
    ]
  },
  {
    name: 'speed',
    label: 'Speed',
    type: 'multiSelect',
    isRequired: false,
    isVisible: true,
    options: [
      {
        label: 'Fibre Internet 1G: 940/940 Mbps',
        value: 'Fibre Internet 1G: 940/940 Mbps'
      },
      {
        label: 'Fibre Internet 150: 150/150 Mbps',
        value: 'Fibre Internet 150: 150/150 Mbps'
      },
      {
        label: 'Fibre Internet 300: 300/300 Mbps',
        value: 'Fibre Internet 300: 300/300 Mbps'
      },
      {
        label: 'Fibre Internet 1.5G: 1.5G/940Mbps',
        value: 'Fibre Internet 1.5G: 1.5G/940Mbps'
      },
      {
        label: 'Fibre Internet 2.5G: 2500 Mbps',
        value: 'Fibre Internet 2.5G: 2500 Mbps'
      },
      {
        label: 'Fibre Internet 3G: 3000 Mbps',
        value: 'Fibre Internet 3G: 3000 Mbps'
      },
      {
        label: 'Fibre Internet 5G: 5000 Mbps',
        value: 'Fibre Internet 5G: 5000 Mbps'
      },
      {
        label: 'Office Internet Basic: 15/1 Mbps',
        value: 'Office Internet Basic: 15/1 Mbps'
      },
      {
        label: 'Office Internet: 25/5 Mbps',
        value: 'Office Internet: 25/5 Mbps'
      },
      {
        label: 'Office Internet Plus: 50/10 Mbps',
        value: 'Office Internet Plus: 50/10 Mbps'
      },
      {
        label: 'Office Internet Enhanced: 75/15 Mbps',
        value: 'Office Internet Enhanced: 75/15 Mbps'
      },
      {
        label: 'Office Internet Professional: 100/20 Mbps',
        value: 'Office Internet Professional: 100/20 Mbps'
      },
      {
        label: 'Office Internet Complete: 150/25 Mbps',
        value: 'Office Internet Complete: 150/25 Mbps'
      }
    ]
  },
  // T015 [US3]: Offer Type — mandatory single-select; determines which tab the offer appears in for sales reps
  {
    name: 'offerType',
    label: 'Offer Type',
    type: 'dropdown',
    isRequired: true,
    isVisible: true,
    options: [
      { label: 'Plans', value: 'Plans' },
      { label: 'Add Ons', value: 'Add Ons' },
      { label: 'Other Offers', value: 'Other Offers' }
    ]
  },
  {
    name: 'couponBasedDiscount',
    label: 'Coupon Based Discount',
    type: 'dropdown',
    isRequired: true,
    isVisible: true,
    options: [
      { label: 'Yes', value: 'Yes' },
      { label: 'No', value: 'No' }
    ]
  },
  {
    name: 'offerCode',
    label: 'Offer Code',
    type: 'string',
    isRequired: true,
    isVisible: true,
    isDisabled: false
  },
  {
    name: 'validationCode',
    label: 'Mandatory Validation Code',
    type: 'dropdown',
    isRequired: false,
    isVisible: true,
    options: [
      { label: 'Yes', value: 'Yes' },
      { label: 'No', value: 'No' }
    ]
  },
  {
    name: 'bundled',
    label: 'Bundled',
    type: 'multiSelect',
    isRequired: true,
    isVisible: true,
    options: [
      { label: 'Yes', value: 'Yes' },
      { label: 'No', value: 'No' }
    ]
  },
  {
    name: 'offerCodesNotStackable',
    label: 'Offer Codes Not Stackable',
    type: 'multiSelect',
    isRequired: false,
    isVisible: true,
    optionsKey: 'offerCodes',
    options: []
  },
  // {
  //   name: 'descriptionEn',
  //   label: 'Offer Description (English)',
  //   type: 'string',
  //   isRequired: true,
  //   isVisible: true
  // },
  // {
  //   name: 'descriptionFr',
  //   label: 'Offer Description (French)',
  //   type: 'string',
  //   isRequired: false,
  //   isVisible: true
  // },
  {
    name: 'offerDetailsEn',
    label: 'Offer Details (English)',
    type: 'string',
    isRequired: true,
    isVisible: false
  },
  {
    name: 'offerDetailsFr',
    label: 'Offer Details (French)',
    type: 'string',
    isRequired: false,
    isVisible: false
  },
  {
    name: 'value',
    label: 'Value ($)',
    type: 'number',
    isRequired: true,
    isVisible: false
  },
  {
    name: 'frequency',
    label: 'Frequency',
    type: 'dropdown',
    isRequired: true,
    isVisible: false,
    options: [
      { label: 'Monthly', value: 'monthly' },
      { label: 'One Time', value: 'oneTime' }
    ]
  },
  {
    name: 'expiredAt',
    label: 'Expiry Date',
    type: 'date',
    isRequired: true,
    isVisible: true
  },
  {
    name: 'note',
    label: 'Note',
    type: 'string',
    isRequired: false,
    isVisible: true
  }
];

export const initialFormValues = {
  province: [],
  channels: [],
  dealerships: [],
  product: [],
  term: [],
  speed: [],
  couponBasedDiscount: '',
  offerCode: '',
  validationCode: '',
  bundled: [],
  offerType: '',
  tsbPlan: [],
  offerCodesNotStackable: [],
  offerDetails: [],
  // descriptionEn: '',
  // descriptionFr: '',
  offerDetailsEn: '',
  offerDetailsFr: '',
  value: 0,
  frequency: '',
  expiredAt: '',
  note: ''
};

export const termName = {
  'oneTime': 'One Time',
  'monthly': 'Monthly'
}
